import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
export default class SyncPlayerModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "player", void 0);
    _defineProperty(this, "apiData", null);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "isLinkingNew", false);
    _defineProperty(this, "selectedFields", {});
  }
  className() {
    return 'SyncPlayerModal Modal--large';
  }
  title() {
    return app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.title');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.player = this.attrs.player;
    this.isLinkingNew = Boolean(this.attrs.isLinkingNew);
    if (this.attrs.apiPlayerData) {
      this.apiData = this.attrs.apiPlayerData;
      this.initSelectedFields();
    } else if (this.player && this.player.apiId()) {
      this.fetchApiProfile(this.player.apiId());
    }
  }
  fetchApiProfile(apiId) {
    this.loading = true;
    m.redraw();
    const type = this.player.entityType() || 'player';
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/player-api-profile',
      params: {
        apiId,
        type
      }
    }).then(response => {
      this.loading = false;
      this.apiData = response.data || null;
      this.initSelectedFields();
      m.redraw();
    }).catch(err => {
      var _err$response;
      this.loading = false;
      console.error(err);
      const status = (err == null ? void 0 : err.status) || (err == null || (_err$response = err.response) == null ? void 0 : _err$response.status);
      let msg = '';
      if (status === 404) {
        msg = String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.alerts.not_found'));
      } else {
        msg = err && err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].detail || err && err.response && err.response.error || app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.alerts.error_sync');
      }
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  initSelectedFields() {
    if (!this.apiData) return;
    const fields = ['photoUrl', 'name', 'number', 'position', 'birthDate', 'birthPlace', 'height', 'weight'];
    this.selectedFields = {};
    fields.forEach(f => {
      const apiVal = this.getNormalizedApiVal(f);
      const localVal = this.getNormalizedLocalVal(f);

      // Si el proveedor tiene un valor
      if (apiVal !== null && apiVal !== '') {
        // Marcar si el valor local está vacío o si es diferente
        if (localVal === null || localVal === '') {
          this.selectedFields[f] = true;
        } else if (String(localVal).trim() !== String(apiVal).trim()) {
          this.selectedFields[f] = true;
        } else {
          this.selectedFields[f] = false;
        }
      } else {
        this.selectedFields[f] = false;
      }
    });
  }
  getNormalizedLocalVal(field) {
    if (!this.player) return null;
    switch (field) {
      case 'photoUrl':
        return this.player.photoUrl() || null;
      case 'name':
        return this.player.name() || null;
      case 'number':
        return this.player.number() !== null ? this.player.number() : null;
      case 'position':
        return this.player.position() || null;
      case 'birthDate':
        return this.player.birthDate() || null;
      case 'birthPlace':
        return this.player.birthPlace() || null;
      case 'height':
        return this.player.height() || null;
      case 'weight':
        return this.player.weight() || null;
      default:
        return null;
    }
  }
  getNormalizedApiVal(field) {
    if (!this.apiData) return null;
    switch (field) {
      case 'photoUrl':
        return this.apiData.photoUrl || null;
      case 'name':
        return this.apiData.name || null;
      case 'number':
        return this.apiData.number !== undefined && this.apiData.number !== null ? this.apiData.number : null;
      case 'position':
        return this.apiData.position || null;
      case 'birthDate':
        return this.apiData.birthDate || null;
      case 'birthPlace':
        return this.apiData.birthPlace || null;
      case 'height':
        return this.apiData.height ? String(this.apiData.height).replace(/\D/g, '') : null;
      case 'weight':
        return this.apiData.weight ? String(this.apiData.weight).replace(/\D/g, '') : null;
      default:
        return null;
    }
  }
  translatePos(pos) {
    if (!pos) return '-';
    const key = pos.toLowerCase();
    const trans = app.translator.trans("bizkaitarra-lineup.forum.players_mgmt.positions.".concat(key));
    return trans && !trans.includes('bizkaitarra-lineup') ? String(trans) : pos;
  }
  toggleSelectAll(checked) {
    Object.keys(this.selectedFields).forEach(k => {
      const apiVal = this.getNormalizedApiVal(k);
      if (apiVal !== null && apiVal !== '') {
        this.selectedFields[k] = checked;
      }
    });
  }
  applySync() {
    const selectedKeys = Object.keys(this.selectedFields).filter(k => this.selectedFields[k]);
    if (selectedKeys.length === 0 && !this.isLinkingNew) {
      alert(String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.alerts.no_selection')));
      return;
    }
    this.saving = true;
    m.redraw();
    const updateAttributes = {};
    if (this.isLinkingNew && this.apiData && this.apiData.apiId) {
      updateAttributes.apiId = this.apiData.apiId;
    }
    selectedKeys.forEach(k => {
      const val = this.getNormalizedApiVal(k);
      switch (k) {
        case 'photoUrl':
          updateAttributes.photoUrl = val;
          break;
        case 'name':
          updateAttributes.name = val;
          break;
        case 'number':
          updateAttributes.number = val;
          break;
        case 'position':
          updateAttributes.position = val;
          break;
        case 'birthDate':
          updateAttributes.birthDate = val;
          break;
        case 'birthPlace':
          updateAttributes.birthPlace = val;
          break;
        case 'height':
          updateAttributes.height = val ? String(val).replace(/\D/g, '') : null;
          break;
        case 'weight':
          updateAttributes.weight = val ? String(val).replace(/\D/g, '') : null;
          break;
      }
    });
    app.request({
      method: 'PATCH',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/players/".concat(this.player.id()),
      body: {
        data: {
          type: 'nagusi_players',
          id: this.player.id(),
          attributes: updateAttributes
        }
      }
    }).then(res => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.alerts.success_sync')));
      this.hide();
      if (this.attrs.onSync) {
        this.attrs.onSync(res);
      }
    }).catch(err => {
      this.saving = false;
      console.error(err);
      const msg = err && err.response && err.response.errors && err.response.errors[0] && err.response.errors[0].detail || String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.alerts.error_sync'));
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null), m("p", {
        style: "margin-top: 15px; color: var(--muted-color);"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.loading')));
    }
    if (!this.apiData) {
      return m("div", {
        className: "Modal-body",
        style: "padding: 30px; text-align: center;"
      }, m("div", {
        style: "margin-bottom: 20px;"
      }, m("i", {
        className: "fas fa-search-minus",
        style: "font-size: 3rem; color: var(--muted-color); opacity: 0.6; margin-bottom: 12px; display: block;"
      }), m("p", {
        style: "color: var(--muted-color); font-size: 1.05em; margin: 0;"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.not_found_msg'))), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.hide()
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.btn_cancel')));
    }
    const allFieldsMeta = [{
      key: 'photoUrl',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_photo'),
      isImage: true
    }, {
      key: 'name',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.column_name')
    }, {
      key: 'number',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.number'),
      isNumber: true
    }, {
      key: 'position',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.position'),
      isPosition: true
    }, {
      key: 'birthDate',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_date')
    }, {
      key: 'birthPlace',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.birth_place')
    }, {
      key: 'height',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.height'),
      unit: 'cm'
    }, {
      key: 'weight',
      label: app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.fields.weight'),
      unit: 'kg'
    }];

    // Filtrar exclusivamente los campos que cambian o que el foro no tiene
    const fieldsMeta = allFieldsMeta.filter(meta => {
      const apiVal = this.getNormalizedApiVal(meta.key);
      if (apiVal === null || apiVal === '') return false;
      const localVal = this.getNormalizedLocalVal(meta.key);
      if (localVal === null || localVal === '') return true;
      return String(localVal).trim() !== String(apiVal).trim();
    });

    // Si no hay diferencias entre los datos locales y los del proveedor
    if (fieldsMeta.length === 0) {
      return m("div", {
        className: "Modal-body",
        style: "padding: 35px 25px; text-align: center;"
      }, m("div", {
        style: "margin-bottom: 25px;"
      }, m("i", {
        className: "fas fa-check-circle",
        style: "font-size: 3.5rem; color: #4ade80; margin-bottom: 15px; display: block;"
      }), m("h3", {
        style: "font-size: 1.25em; font-weight: bold; color: var(--heading-color); margin-bottom: 8px;"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.all_synced_msg')), m("p", {
        style: "color: var(--muted-color); font-size: 0.95em; margin: 0;"
      }, this.player ? this.player.name() : '', " (#", this.apiData.apiId, ")")), m(Button, {
        className: "Button Button--primary",
        onclick: () => this.hide(),
        style: "border-radius: 8px; font-weight: bold; padding: 10px 24px;"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.btn_cancel')));
    }
    const selectedCount = Object.keys(this.selectedFields).filter(k => this.selectedFields[k]).length;
    return m("div", {
      className: "Modal-body",
      style: "padding: 25px;"
    }, m("div", {
      style: "background: rgba(59, 130, 246, 0.08); border: 1px solid rgba(59, 130, 246, 0.2); border-radius: 12px; padding: 14px 18px; margin-bottom: 20px; font-size: 0.9em; display: flex; align-items: center; justify-content: space-between; gap: 15px; flex-wrap: wrap;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "fas fa-sync-alt",
      style: "color: #60a5fa; font-size: 1.4rem;"
    }), m("div", null, m("strong", null, this.player ? this.player.name() : ''), " (ID Foro: ", m("code", null, "#", this.player ? this.player.id() : ''), ") \u2794 ID Proveedor: ", m("code", null, "#", this.apiData.apiId), m("div", {
      style: "font-size: 0.85em; color: var(--muted-color); margin-top: 2px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.subtitle')))), m("div", {
      style: "display: flex; gap: 8px;"
    }, m("button", {
      type: "button",
      className: "Button Button--link Button--small",
      onclick: () => this.toggleSelectAll(true),
      style: "font-size: 0.8em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.select_all')), m("span", {
      style: "color: var(--muted-color);"
    }, "|"), m("button", {
      type: "button",
      className: "Button Button--link Button--small",
      onclick: () => this.toggleSelectAll(false),
      style: "font-size: 0.8em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.deselect_all')))), m("div", {
      style: "border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; overflow: hidden; background: rgba(255,255,255,0.02); margin-bottom: 20px;"
    }, m("div", {
      style: "display: grid; grid-template-columns: 1fr 1.2fr 1.2fr 80px; background: rgba(255,255,255,0.05); padding: 10px 16px; font-weight: bold; font-size: 0.85em; border-bottom: 1px solid rgba(255,255,255,0.08); text-transform: uppercase; letter-spacing: 0.5px; color: var(--muted-color);"
    }, m("div", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.col_field')), m("div", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.col_current')), m("div", null, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.col_provider')), m("div", {
      style: "text-align: center;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.col_update'))), m("div", {
      style: "display: flex; flex-direction: column;"
    }, fieldsMeta.map((meta, idx) => {
      const localVal = this.getNormalizedLocalVal(meta.key);
      const apiVal = this.getNormalizedApiVal(meta.key);
      const hasApiVal = apiVal !== null && apiVal !== '';
      const isSelected = Boolean(this.selectedFields[meta.key]);
      let localDisplay = localVal || m("span", {
        style: "color: var(--muted-color); font-style: italic;"
      }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.empty_value'));
      let apiDisplay = apiVal ? "".concat(apiVal).concat(meta.unit ? ' ' + meta.unit : '') : m("span", {
        style: "color: var(--muted-color); font-style: italic;"
      }, "-");
      if (meta.isImage) {
        localDisplay = localVal ? m("img", {
          src: localVal,
          alt: "Local",
          style: "width: 36px; height: 36px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.15);"
        }) : m("span", {
          style: "color: var(--muted-color); font-style: italic;"
        }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.empty_value'));
        apiDisplay = apiVal ? m("img", {
          src: apiVal,
          alt: "API",
          style: "width: 36px; height: 36px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.15);"
        }) : m("span", {
          style: "color: var(--muted-color); font-style: italic;"
        }, "-");
      } else if (meta.isPosition) {
        localDisplay = this.translatePos(localVal);
        apiDisplay = hasApiVal ? this.translatePos(apiVal) : '-';
      } else if (meta.isNumber) {
        localDisplay = localVal !== null ? "#".concat(localVal) : m("span", {
          style: "color: var(--muted-color); font-style: italic;"
        }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.empty_value'));
        apiDisplay = hasApiVal ? "#".concat(apiVal) : '-';
      } else if (meta.unit && localVal) {
        localDisplay = "".concat(localVal, " ").concat(meta.unit);
      }
      return m("div", {
        key: meta.key,
        style: "display: grid; grid-template-columns: 1fr 1.2fr 1.2fr 80px; align-items: center; padding: 12px 16px; border-bottom: ".concat(idx < fieldsMeta.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none', "; background: ").concat(isSelected ? 'rgba(59, 130, 246, 0.04)' : 'transparent', "; transition: background 0.15s;")
      }, m("div", {
        style: "font-weight: 600; color: var(--heading-color); font-size: 0.95em;"
      }, meta.label), m("div", {
        style: "font-size: 0.9em; color: var(--heading-color); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 10px;"
      }, localDisplay), m("div", {
        style: "font-size: 0.9em; color: #4ade80; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 10px; display: flex; align-items: center; gap: 8px;"
      }, apiDisplay), m("div", {
        style: "text-align: center;"
      }, m("input", {
        type: "checkbox",
        disabled: !hasApiVal,
        checked: isSelected,
        onchange: e => {
          this.selectedFields[meta.key] = e.target.checked;
          m.redraw();
        },
        style: "width: 20px; height: 20px; cursor: hasApiVal ? 'pointer' : 'not-allowed'; accent-color: var(--primary-color);"
      })));
    }))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 12px; align-items: center;"
    }, m(Button, {
      className: "Button",
      onclick: () => this.hide(),
      disabled: this.saving
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.btn_cancel')), m(Button, {
      className: "Button Button--primary",
      onclick: this.applySync.bind(this),
      loading: this.saving,
      style: "border-radius: 8px; font-weight: bold; padding: 10px 20px;"
    }, m("i", {
      className: "fas fa-check-circle",
      style: "margin-right: 6px;"
    }), selectedCount > 0 ? "Aplicar ".concat(selectedCount, " cambio").concat(selectedCount > 1 ? 's' : '') : app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.sync_modal.btn_apply'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/SyncPlayerModal', SyncPlayerModal);